import { RBACPolicyRole } from '@stytch/core';

export const getRoleDefaultDisplayName = (role: RBACPolicyRole) => role.role_id;
